import React from "react";
import { Result } from "antd";
import { OZResultType } from "helpers/types";

const OZResult = ({ extra, status, subTitle, title }: OZResultType) => {
    return <Result status={status} title={title} subTitle={subTitle} extra={extra} />;
};

export default OZResult;
